 /* globals urls, RSVP */
 
// This pattern can be used to quickly spin up specific loaders for various sections of the site
var $ = jQuery.noConflict();
window.KoisLoader = function(){
	this.RSVP = RSVP;
	
	// The following should be overridden for classes using this pattern
	this.validSections = [];
	this.requestData = {
		action: 'fetch_loader_sections'
	};
	this.sectionMappings = {
		sectionName: {id: 'section-name-dom-id'}
	};
};

/*
 * ONE LOADER TO RULE THEM ALL,
 * ONE LOADER TO FIND THEM;
 * ONE LOADER TO LOAD YOUR DATA,
 * AND TO THE CORRECT DOM ELEMENT BIND THEM
 * 
 * Loads all specified loader sections using individual Promises, displays rotating
 * loading messages in the specified loader element, and creates an additional Promise 
 * which hides the loader once all section Promises have resolved.
 */
KoisLoader.prototype.oneLoaderToRuleThemAll = function(sections, loaderSelector){
	// Setup
	var self = this;
	var sectionsArray = this.normalizeSectionsArray(sections);
	$(loaderSelector).addClass('loading');
	var loaderMessagesInterval = this.startLoadingMessageInterval(4500, loaderSelector);
	
	// Create a promise for each section which will be resolved individually as data is fetched from method
	// Store all the resulting promises in an array
	var promises = sectionsArray.map(function(section){
		var requestSection = [section];
		var promise = self.requestSections(requestSection);
		promise.then(function(sectionsMarkup){
			self.initSectionsFrontEnd(sectionsMarkup, requestSection);
		}).catch(function(err){
			self.handleError(err, requestSection);
		});
		return promise;
	});
	
	// Create one more promise which will be resolved once all the individual section promises
	// have been settled (i.e. resolved or rejected). Hide the mega-loader once complete.
	this.RSVP.allSettled(promises).then(function(results){
		$(loaderSelector).removeClass('loading').fadeOut();
		window.clearInterval(loaderMessagesInterval);
	}).catch(function(err){
		$(loaderSelector).removeClass('loading').fadeOut();
		window.clearInterval(loaderMessagesInterval);
	});
};

// Takes an array of loader section names
KoisLoader.prototype.requestSections = function(sections){
	var self = this;
	var data = self.requestData;
	data.sections = sections.join(',');
	return new this.RSVP.Promise(function( resolve, reject ){
		if( !self.isSectionsArrayValid( sections ) ){
			reject( 'Unsupported loader section(s) specified' );
		}
		
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: data
		})
		.done(function( res ) {
			if( res ){
				resolve( res );
			}
			reject( 'An error occurred while loading your data' );
		}).fail(function( jqXHR, textStatus ) {
			reject( 'An error occurred while loading your data' );
		});
	});
};

KoisLoader.prototype.initSectionsFrontEnd = function(sectionsMarkup, requestedSections){
	var self = this;
	
	for(var i = 0; i < requestedSections.length; i++){
		var sectionName = requestedSections[i];
		var sectionMarkup = '';
		if( this.sectionMappings[sectionName] ){
			var id = this.sectionMappings[sectionName].id;
			if( sectionsMarkup[sectionName] ){
				sectionMarkup += sectionsMarkup[sectionName];
			}
			$('#'+id).fadeOut(function(){
				$(this).removeClass('loading').html(sectionMarkup).fadeIn(function(){
					// Init JS events
					self.initSectionEventHandlers(this, sectionName);
				});
			});
		}
	}
};

KoisLoader.prototype.initSectionEventHandlers = function(sectionContain, sectionName){
	// TODO: Implement this in classes which follow this pattern
};

KoisLoader.prototype.startLoadingMessageInterval = function(interval, loaderSelector){
	return window.setInterval(function(){
		var messages = $(loaderSelector + ' p.loading-message');
		var messageCount = messages.length;
		var firstElement = messages.first();
		var activeElement = messages.filter('.show');
		if( messageCount > 1 ){
			// Special case for the first run, display the first element
			var nextElement = ( activeElement.next('p.loading-message').length ? activeElement.next('p.loading-message') : firstElement );
			activeElement.fadeOut(function(){
				$(this).removeClass('show');
				nextElement.fadeIn(function(){
					$(this).addClass('show');
				});
			});
		}
	}, interval);
};

// Check if the specified loader sections array is valid
KoisLoader.prototype.isSectionsArrayValid = function(sections){
	if(Array.isArray(sections) && sections.length === 1 && sections[0] === 'all'){
		return true;
	}
	else if(Array.isArray(sections) && sections.length > 0){
		for(var i = 0; i < sections.length; i++){
			// Must be a string
			if(typeof sections[i] !== 'string'){
				return false;
			}
			// If there are multiple sections, none of them can be 'all'
			else if(sections[i] === 'all'){
				return false;
			}
			// Must be in the list of valid sections
			else if(this.validSections.indexOf(sections[i]) === -1){
				return false;
			}
		}
		return true;
	}
	else{
		return false;
	}
};

KoisLoader.prototype.normalizeSectionsArray = function(sections){
	var self = this;
	if(typeof sections === 'string'){
		sections = [sections];
	}
	else if(Array.isArray(sections) && sections.length === 1 && sections[0] === 'all'){
		sections = self.validSections;
	}
	
	return sections;
};

KoisLoader.prototype.handleError = function(err, requestedSections){
	var sectionErrorMarkup = '<em>An error occurred: ' + err + '</em>';
	for(var i = 0; i < requestedSections.length; i++){
		var sectionName = requestedSections[i];
		if( this.sectionMappings[sectionName] ){
			var id = this.sectionMappings[sectionName].id;
			$('#'+id).removeClass('loading').html(sectionErrorMarkup);
		}
	}
};